module.exports = __webpack_public_path__ + "img/chpc_index_honor5.d5c22b9a.png";